import * as React from 'react';
import classNames from 'classnames';
import { ColumnWidth } from '../theme';

type ColumnWidthWithoutFull = Exclude<ColumnWidth, 12>;

type FormGroupPropsWithColumns = {
    fullWidth?: undefined;
    labelColumnWidth?: ColumnWidthWithoutFull;
};

type FormGroupPropsFullWidth = {
    fullWidth: true;
};

export type FormGroupProps = {
    children?: React.ReactNode;
    className?: string;
    label?: JSX.Element | string;
} & (FormGroupPropsFullWidth | FormGroupPropsWithColumns);

export const FormGroup: React.FC<FormGroupProps> = ({ children, className, label, ...allProps }) => {
    let props;
    let labelColumnWidth = 3;
    let useColumns = label !== undefined;
    if (!allProps.fullWidth) {
        const {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            labelColumnWidth: _labelColumnWidth = 3,
            ...otherProps
        } = allProps;
        labelColumnWidth = _labelColumnWidth;
        props = {
            ...otherProps,
        };
    } else {
        const { fullWidth, ...otherProps } = allProps;
        useColumns = !fullWidth;
        props = {
            ...otherProps,
        };
    }
    return (
        <div
            className={classNames(
                'form-group',
                {
                    row: useColumns,
                },
                className,
            )}
            {...props}
        >
            {label && (
                <label
                    className={classNames('control-label', {
                        [`col-sm-${labelColumnWidth || 3}`]: useColumns,
                    })}
                >
                    {label}
                </label>
            )}
            {useColumns ? (
                <div
                    className={classNames({
                        [`col-sm-${12 - labelColumnWidth}`]: useColumns,
                    })}
                >
                    {children}
                </div>
            )
                : children
            }
        </div>
    );
};
